












import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { ProsemirrorHelper } from '../../helpers/prosemirror.helper';
import type { Field } from '../../types';

export default defineComponent({
  name: 'PricingTableCheckbox',
  props: {
    disabled: { type: Boolean, default: false },
    input: { type: Object as PropType<Field>, required: true },
  },
  setup(props, { emit }) {
    const inputId = computed(() => props.input?.id);
    const inputValue = computed(() => props.input?.value);

    const handleUpdateChecked = (checked: boolean) => {
      emit(
        'update-checked',
        { ...props.input, value: checked ? '1' : '0' },
        'optionalProductFieldId'
      );
    };

    return { handleUpdateChecked, ProsemirrorHelper, inputId, inputValue };
  },
});
